import axios from 'axios';

export const logo = async () => {
  const response = await axios.get('general-components/header');

  return response?.data;
};
